import "./TaskSummary.scss";

export const taskSummaryStyles = {
  count: "im-task-summary__count",
  icon: "im-task-summary__icon",
  button: "im-task-summary__button",
};
